export const getOpportunityStageNameI18n = (stageName?: string | null) => {
  switch (stageName) {
    case 'Closed Won':
      return $localize`:@@general.completed:Abgeschlossen`;
    case 'Closed Lost':
      return $localize`:@@general.cancelled:Abgebrochen`;
    // In this case, default will not be the SF value but open. There are multiple deprecated stage names still in use (at least in dev) all mapping to open.
    // Also, in this case, this will be the most likely option for any new state added. Not fail save but good enough.
    default:
      return $localize`:@@general.pending:Offen`;
  }
};

export const getAccountDirectDebitMethodI18n = (directDebitMethod?: string | null) => {
  switch (directDebitMethod) {
    case 'Einzug Subscriptions':
      return $localize`:@@account.directDebit.recurringPayments:Einzug für wiederkehrende Zahlungen`;
    case 'Einzug Assets':
      return $localize`:@@account.directDebit.oneTimePayments:Einzug für einmalige Zahlungen`;
    case 'Einzug Assets und Subscriptions':
      return $localize`:@@account.directDebit.allPayments:Einzug für alle Zahlungen`;
    case 'Keine Lastschrift':
      return $localize`:@@account.directDebit.none:Keine Lastschrift`;
    default:
      return directDebitMethod;
  }
};

export const getCaseCriticalityI18n = (criticality?: number | null) => {
  switch (criticality) {
    case 1:
      return $localize`:@@ticket.criticality.high:🔴 Betriebsverhindernd, Totalausfall, Arbeiten unmöglich`;
    case 2:
      return $localize`:@@ticket.criticality.medium:🟡 Schwerwiegend eingeschränkt, Arbeiten eingeschränkt möglich`;
    case 3:
      return $localize`:@@ticket.criticality.low:🟢 Geringe Dringlichkeit, Fragen zu Anwendungen, Unklarheiten über Programmfunktionen`;
    default:
      return criticality;
  }
};

export const getInvoiceShippingMethodsI18n = (shippingMethod?: string | null) => {
  switch (shippingMethod) {
    case 'Brief':
      return $localize`:@@customer.invoiceShippingMethod.letter:Brief`;
    case 'Mail':
      return $localize`:@@customer.invoiceShippingMethod.mail:E-Mail`;
    default:
      return shippingMethod;
  }
};

export const getChangeRequestI18n = (changeRequest?: string | null) => {
  switch (changeRequest) {
    case 'Brief':
      return $localize`:@@customer.invoiceShippingMethod.letter:Brief`;
    case 'Mail':
      return $localize`:@@customer.invoiceShippingMethod.mail:E-Mail`;
    case 'Einzug Subscriptions':
      return $localize`:@@account.directDebit.recurringPayments:Einzug für wiederkehrende Zahlungen`;
    case 'Einzug Assets':
      return $localize`:@@account.directDebit.oneTimePayments:Einzug für einmalige Zahlungen`;
    case 'Einzug Assets und Subscriptions':
      return $localize`:@@account.directDebit.allPayments:Einzug für alle Zahlungen`;
    case 'Keine Lastschrift':
      return $localize`:@@account.directDebit.none:Keine Lastschrift`;
    default:
      return changeRequest;
  }
};

export const getServiceAppointmentBillingTypeI18n = (billingType: string): string => {
  switch (billingType) {
    case 'kostenpflichtig':
      return $localize`:@@appointment.price.chargable:Kostenpflichtig`;
    case 'kostenfrei':
      return $localize`:@@appointment.price.free:Kostenfrei`;
    case 'Auftragsbestandteil':
      return $localize`:@@appointment.price.included:Auftragsbestandteil`;
    default:
      return billingType;
  }
};

export const getServiceAppointmentBillingTypeInfoI18n = (billingType?: string | null): string => {
  switch (billingType) {
    case 'kostenpflichtig':
      return $localize`:@@appointment.price.chargableInfo:Bitte beachten Sie, dass Dienstleistungen per Fernwartung nach tatsächlichem Aufwand je angefangener Arbeitseinheit (AE) abgerechnet werden. Eine Arbeitseinheit entspricht 15 Minuten. Der Stundensatz beläuft sich aktuell auf 155,00 Euro, daher entspricht eine Arbeitseinheit (AE) 38,75 Euro.`;
    case 'kostenfrei':
      return $localize`:@@appointment.price.freeInfo:Nach Absprache mit der Fachabteilung erfolgt der Termin kostenfrei.`;
    case 'Auftragsbestandteil':
      return $localize`:@@appointment.price.includedInfo:Die Abrechnung erfolgt gemäß Auftrag.`;
    default:
      return '';
  }
};
